import { darken, fade, lighten } from "@material-ui/core/styles/colorManipulator";
import { ThemeType } from "./bonliva";

export const listItem = (theme: ThemeType) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),

  "& svg": {
    color: `${theme.mainMenu.iconsColor.default}!important`,

    width: 19,
    height: 19
  },

  "&.active": {
    backgroundColor: theme.palette.primary.background,
    boxShadow: `inset 3px 0 0 ${theme.palette.primary.main}`,

    "& svg": {
      color: `${theme.mainMenu.iconsColor.active}!important`
    },

    "& h3": {
      color: `${theme.mainMenu.textColor.active}!important`
    }
  },

  "& h3, & span": {
    color: `${theme.mainMenu.textColor.default}!important`,
    fontFamily: "'Inter', sans-serif !important",
    fontSize: "0.875rem !important",
    fontWeight: "500 !important" as any,
    letterSpacing: "-0.01em"
  }
});

export const listSubItem = (theme: ThemeType) => ({
  paddingLeft: `${theme.spacing(1)} !important`
});

export const withListItem = (theme: ThemeType) => ({
  listItem: listItem(theme),
  listSubItem: listSubItem(theme),
  listItemText: { paddingLeft: 0 }
});

export const highlightOnHover = (theme: ThemeType) => ({
  transition: theme.transitions.create("background-color"),

  "&:hover": {
    backgroundColor: theme.palette.background.active
  }
});

// see https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/TableCell/TableCell.js
export const tableCell = (theme: ThemeType) => {
  const borderColor =
    theme.palette.type === "light"
      ? lighten(fade(theme.palette.divider, 1), 0.88)
      : darken(fade(theme.palette.divider, 1), 0.68);

  return {
    borderTop: `1px solid ${borderColor}`,
    "&:last-child": {
      borderBottom: `1px solid ${borderColor}`
    }
  };
};

// see https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/TableRow/TableRow.js
export const tableRow = (theme: ThemeType) => ({
  "&$selected": {
    backgroundColor:
      theme.palette.type === "light"
        ? "rgba(0, 0, 0, 0.04)" // grey[100]
        : "rgba(255, 255, 255, 0.08)"
  }
});
